import type { ShiftBatchCreateForm, ShiftRecurrentCreateForm, ShiftForm, ShiftBatchUpdateForm } from './shifts';
import { api } from './index';

const BASE_PATH = '/api/internal/shift_conflicts';

interface ExistingShift {
  // null: another candidate of the same batch, not a saved shift.
  id: number | null;
  date: string;
  humanTime: string;
  patientName: string;
  caregiverName: string;
  caregiverCareer: string;
  caregiverHumanCareer: string;
}

export interface ScheduleBlockConflict {
  id: number;
  description: string;
  humanPeriod: string;
  careers: Array<string>;
  humanCareers: string;
}

export interface OutsideRequirementConflict {
  id: number;
  humanCareer: string;
  humanPeriod: string;
}

interface ConflictDetail {
  newShift: {
    date: string;
    humanTime: string;
  };
  existingShifts: Array<ExistingShift>;
  scheduleBlocks?: Array<ScheduleBlockConflict>;
  // The patient's requirements of the caregiver's career, none of which covers the shift date.
  outsideRequirements?: Array<OutsideRequirementConflict>;
}

export interface ShiftConflict {
  caregiverId: number;
  caregiverName: string;
  caregiverHumanCareer: string | null;
  conflictsCount: number;
  scheduleBlocksCount?: number;
  outsideRequirementsCount?: number;
  details: Array<ConflictDetail>;
}

interface DetectConflictsResponse {
  shiftsConflicts: Array<ShiftConflict>;
}

export const shiftConflictsApi = {
  create(
    shiftsFormData: ShiftBatchCreateForm | ShiftRecurrentCreateForm,
  ): Promise<DetectConflictsResponse> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { shifts: shiftsFormData },
    }).then(response => response.data);
  },
  update(shiftForm: ShiftForm): Promise<DetectConflictsResponse> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${shiftForm.id}`,
      data: { shift: shiftForm },
    }).then(response => response.data);
  },
  batchUpdate(shiftBatchUpdateForm: ShiftBatchUpdateForm): Promise<DetectConflictsResponse> {
    return api({
      method: 'put',
      url: BASE_PATH,
      data: { shifts: shiftBatchUpdateForm },
    }).then(response => response.data);
  },
};
